import React from "react";
import { Card, Typography, Row, Col, Tag } from "antd";
import { ApiOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const MCPBanner: React.FC = () => {
  return (
    <Card
      variant="borderless"
      className="shadow-card"
      style={{
        marginBottom: 16,
        borderRadius: 8,
        background: "linear-gradient(135deg, #722ED1 0%, #9254DE 100%)",
        position: "relative",
      }}
      styles={{
        body: { padding: "30px" },
      }}
    >
      <Tag
        color="rgb(178 133 210)"
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          fontSize: "14px",
          padding: "2px 8px",
        }}
      >
        测试版 · 快速迭代中
      </Tag>

      <Row gutter={24} align="middle">
        <Col xs={24} md={16}>
          <Title
            level={2}
            style={{
              color: "white",
              margin: 0,
              marginBottom: 16,
            }}
          >
            MCP 工具服务
          </Title>
          <Paragraph
            style={{
              color: "rgba(255, 255, 255, 0.85)",
              fontSize: 16,
              marginBottom: 0,
            }}
          >
            使用 Model Context Protocol (MCP)
            工具服务，扩展您的AI应用功能。通过MCP，AI可以调用各种工具来执行特定任务，构建专属于您的Agent。
          </Paragraph>
        </Col>
        <Col xs={24} md={8} style={{ textAlign: "center" }}>
          <ApiOutlined
            style={{ fontSize: 80, color: "rgba(255, 255, 255, 0.2)" }}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default MCPBanner;
